import utils from "./axios2.js";
function isAxiosError(payload) {
  return utils.isObject(payload) && payload.isAxiosError === true;
}
export {
  isAxiosError as default
};
//# sourceMappingURL=axios15.js.map
